import { Items } from "../../../../../core";
export const tripImport = {
    show: 'Formato excel debe incluir N° Desp, SKU, Descripción, Pendiente',
    showIcon: './assets/icon/ico_placeholder_documentos.svg',
    exportFile: 'reporte_del_viaje.xlsx',
    paginatorAllData: true,
    columns: [
      {
        title: 'N° Desp',
        name: 'dispatchId',
        type: 'string',
        visible: true,
        editable: false,
        checkAll: false,
        class: 'left',
        value: (element: Items) => element.dispatchId
      },
      {
        title: 'SKU',
        name: 'skuCode',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'center',
        value: (element: Items) => element.skuCode
      },
      {
        title: 'Descripción',
        name: 'skuName',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'center',
        value: (element: Items) => element.skuName
      },
      {
        title: 'Pendiente',
        name: 'processedAmount',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'center',
        value: (element: Items) => element.processedAmount
      }
    ]
  }